import { PaymentService } from '~/types/paymentServices';
import axios from '~/utils/axios';

export const deletePaymentService = (id: string) => {
  return axios.delete<void>(`/paymentServices/${id}`).then((res) => res.data);
};

export const getAllServices = () => {
  return axios.get<PaymentService[]>(`/paymentServices?page=1&perPage=9999`);
};

export const getService = (serviceId: string, forPublicApi: boolean = false) => {
  return axios.get<PaymentService>(`/paymentServices/${serviceId}?forPublicApi=${forPublicApi}`);
};
